import { render, staticRenderFns } from "./Footer_lg.vue?vue&type=template&id=297d1338&scoped=true&"
import script from "./Footer_lg.vue?vue&type=script&lang=js&"
export * from "./Footer_lg.vue?vue&type=script&lang=js&"
import style0 from "./Footer_lg.vue?vue&type=style&index=0&id=297d1338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d1338",
  null
  
)

export default component.exports